import React from "react"
import PropTypes from "prop-types"
import { FaUpload } from "react-icons/fa"
import ReCAPTCHA from "react-google-recaptcha"
import WhatappImg from "../../../images/whatapp-share.png"
import LinkedinImg from "../../../images/linkedin-share.png"

const API_KEY = "6LfWq1MaAAAAACGtHKZCabOClqiJ2c3Z_qH6AuPq"

const FormSpecial = ({
  handleSubmit,
  fullName,
  setFullName,
  email,
  setEmail,
  phoneNumber,
  setPhoneNumber,
  linkedin,
  setLinkedin,
  resume,
  handleChangeUploadResume,
  message,
  setMessage,
  loading,
  isCaptcha,
  veryfyCaptcha,
}) => {
  return (
    <form
      className="flex flex-wrap"
      onSubmit={handleSubmit}
      encType="multipart/form-data"
    >
      <div className="w-full md:w-1/2 pb-4">
        <p className="text-2xl">Información personal</p>
      </div>
      <div className="w-full md:w-1/2 pb-8">
        <input
          className="border-b-2 border-gray-50 bg-primary text-white focus:outline-none py-2 px-4 mb-4 w-full lg:w-4/6"
          placeholder="Nombres"
          type="text"
          name="full_name"
          id="full_name"
          onChange={({ target }) => setFullName(target.value)}
          value={fullName}
          required
        />
        <input
          className="border-b-2 border-gray-50 bg-primary text-white focus:outline-none py-2 px-4 mb-4 w-full lg:w-4/6"
          placeholder="E-mail"
          type="email"
          name="email"
          id="email"
          onChange={({ target }) => setEmail(target.value)}
          value={email}
          required
        />
        <input
          className="border-b-2 border-gray-50 bg-primary text-white focus:outline-none py-2 px-4 mb-4 w-full lg:w-4/6"
          placeholder="Teléfono"
          type="text"
          name="phone_number"
          id="phone_number"
          onChange={({ target }) => setPhoneNumber(target.value)}
          value={phoneNumber}
        />
        <input
          className="border-b-2 border-gray-50 bg-primary text-white focus:outline-none py-2 px-4 mb-4 w-full lg:w-4/6"
          placeholder="Url Linkedin"
          type="text"
          name="linkedin"
          id="linkedin"
          onChange={({ target }) => setLinkedin(target.value)}
          value={linkedin}
          required
        />
      </div>

      <div className="w-full md:w-1/2 pb-4">
        <p className="text-2xl">Hoja de vida / CV</p>
      </div>
      <div className="w-full md:w-1/2 pb-8">
        <label
          htmlFor="file-upload"
          className="cursor-pointer border-white border-b-2 hover:text-variant w-full lg:w-4/6 text-center block mt-0 mb-2 py-2"
        >
          <span>
            <FaUpload className="inline mr-2" />{" "}
            {resume ? "Archivo subido: " + resume.name : "Subir archivo"}
          </span>
          <input
            id="file-upload"
            name="file-upload"
            type="file"
            accept=".doc,.docx,.pdf"
            className="sr-only" //lg:not-sr-only
            onChange={handleChangeUploadResume}
            required
          />
        </label>
        <p className="block italic text-sm text-center md:text-left">
          Solo archivos PDF, DOC y DOCX.
        </p>
      </div>

      <div className="w-full md:w-1/2 pb-4">
        <p className="text-2xl">Cuéntanos de tu nivel de inglés</p>
      </div>
      <div className="w-full md:w-1/2">
        <textarea
          name="message"
          id="message"
          placeholder="Cuéntanos de tu nivel de inglés"
          className="border-b-2 border-gray-50 bg-primary text-white focus:outline-none py-2 px-4 mb-12 w-full lg:w-4/6"
          rows="2"
          onChange={({ target }) => setMessage(target.value)}
          value={message}
        ></textarea>

        <ReCAPTCHA sitekey={API_KEY} onChange={veryfyCaptcha} />
      </div>

      <div className="w-full">
        <button
          type="submit"
          className="btn font-semibold py-2 px-4 mt-20 rounded-lg transition duration-300 ease-in-out mx-auto block bg-secondary disabled:opacity-50"
          disabled={!isCaptcha}
        >
          <svg
            className={
              loading
                ? `h-5 w-5 mr-3 animate-spin inline`
                : `h-5 w-5 mr-3 hidden`
            }
            viewBox="0 0 24 24"
          >
            <circle
              className="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              strokeWidth="4"
            />
            <path
              className="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            />
          </svg>
          Enviar
        </button>
      </div>
      <div className="mx-auto pt-8">
        <p className="pb-8 text-xl text-center">Compártelo</p>
        <div className="flex flex-wrap space-x-4">
          <iframe
            src="https://www.facebook.com/plugins/share_button.php?href=https%3A%2F%2Ffir-avalith.web.app%2Fpromo%2Fskill-factory-it-recruiter%2F&layout=button&size=large&appId=259994465536490&width=103&height=28"
            width="103"
            height="28"
            style={{ border: "none", overflow: "hidden" }}
            scrolling="no"
            frameBorder="0"
            allowFullScreen={true}
            allow="autoplay; clipboard-write; encrypted-media; picture-in-picture;"
            title="Compartir en Facebook"
          ></iframe>
          <a
            href="https://twitter.com/share?ref_src=twsrc%5Etfw"
            className="twitter-share-button"
            data-size="large"
            data-text="Si tienes conocimientos básicos sobre el funcionamiento de áreas de RRHH, nuestra Skill Factory, Inscríbete y continúa creciendo!"
            data-url="https://fir-avalith.web.app/promo/skill-factory-it-recruiter/"
            data-hashtags="#SkillFactory #ItRecruiters"
            data-related="holaAvalith"
            data-show-count="false"
          >
            Tweet
          </a>
          <a href="https://www.linkedin.com/shareArticle?mini=true&url=https://fir-avalith.web.app/promo/skill-factory-it-recruiter/" title="Compartir en Linkedin" target="_blank" rel="noreferrer"><img src={LinkedinImg} alt="Compartir en Linkedin" /> </a>

          <a href="https://api.whatsapp.com/send?text=Si tienes conocimientos básicos sobre el funcionamiento de áreas de RRHH, nuestra Skill Factory, Inscríbete y continúa creciendo! --> https://bit.ly/3bpyJlv" title="Compartir en Whatsapp" data-action="share/whatsapp/share" target="_blank" rel="noreferrer"><img src={WhatappImg} alt="Compartir en Whatsapp" /></a>      
        </div>
      </div>
    </form>
  )
}

FormSpecial.propTypes = {
  handleSubmit: PropTypes.func,
  fullName: PropTypes.string,
  setFullName: PropTypes.func,
  email: PropTypes.string,
  setEmail: PropTypes.func,
  linkedin: PropTypes.string,
  setLinkedin: PropTypes.func,
  handleChangeUploadResume: PropTypes.func,
  message: PropTypes.string,
  setMessage: PropTypes.func,
  loading: PropTypes.bool,
  isCaptcha: PropTypes.bool,
}

export default FormSpecial
